module.exports = __webpack_public_path__ + "img/9.0ad0a1f0.jpg";